'use strict';
// updating this at base cartidge due to stucture of js in TFG is venila format. and require base/details is adding only base code not tfg one.
import cloudinary from '../cloudinary/cloudinary';

module.exports = function () {
    // Custom Start: Make cart product images responsive //
    $(document).on('product:afterAttributeSelect', function (e, response) {
        // custom start: update cloudinary PGW
        let cloudinaryData = document.querySelector('.cloudinary-data');
        if (cloudinaryData) {
            cloudinaryData = cloudinaryData.innerHTML;
            const temp = { detail: JSON.parse(cloudinaryData) };
            cloudinary.updateCloudinaryGalleryWidget(temp.detail);
            // custom end: update cloudinary PGW
            if (response) {
                if ($('.product-detail>.bundle-items').length) {
                    response.container.data('pid', response.data.product.id);
                    response.container.find('.product-id').text(response.data.product.id);
                } else if ($('.product-set-detail').eq(0)) {
                    response.container.data('pid', response.data.product.id);
                    response.container.find('.product-id').text(response.data.product.id);
                } else {
                    $('.product-id').text(response.data.product.id);
                    $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
                }
            }
        }
    });
    // Custom End: Make cart product images responsive //
};
